/**
 * Suburban Streets — baked by ultra_map_editor. Edit via the editor.
 *
 * Do not hand-edit: this file is regenerated wholesale on the next bake, and
 * hand-written comments/formatting do not survive a bake.
 */
import type { WorldData } from '../../types';

export const map: WorldData = {
  cityName: "Suburban Streets",
  ground: { width: 80, depth: 80 },
  spawnPoint: { x: 0, z: 30 },
  groundTexture: { textureUrl: "/textures/ground-realistic.webp", textureScale: 0.16, textureRotation: 0, secondaryUrl: "/textures/ground-stylized.webp", secondaryScale: 0.11, secondaryRotation: 0.82, noiseUrl: "/textures/noise-detailed.webp", noiseScale: 0.05, noiseRotation: -0.4, noiseOffset: -0.06, noiseGain: 0.9 },

  objects: [
    {
      id: "house-w-1",
      kind: "building",
      label: "Abandoned Shack",
      position: { x: -13.257506662719173, z: 26.043135563000327 },
      size: { w: 5.2, d: 4.8, h: 3.4 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_a.glb",
      rotationY: -0.028944290500064127,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "house-w-2",
      kind: "building",
      label: "Abandoned House",
      position: { x: -15.8, z: 15 },
      size: { w: 7.4, d: 6.2, h: 4.6 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_house_dilapidated.glb",
      rotationY: -0.14,
    },
    {
      id: "house-w-3",
      kind: "building",
      label: "Abandoned Shack",
      position: { x: -21.42712339839776, z: 4.857909657423072 },
      size: { w: 5.2, d: 4.8, h: 3.2 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_weathered.glb",
      rotationY: -2.7845669142779146,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "house-w-4",
      kind: "building",
      label: "Abandoned Shack",
      position: { x: -23.30886418750814, z: -12.376037010906305 },
      size: { w: 5.2, d: 4.8, h: 3.5 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_c.glb",
      rotationY: 1.5495407463711781,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "house-w-5",
      kind: "building",
      label: "Abandoned House",
      position: { x: -15.978889484039774, z: -16.201048687481514 },
      size: { w: 7.4, d: 6.2, h: 4.6 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_house_dilapidated.glb",
      rotationY: -0.02950551346451413,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "house-w-6",
      kind: "building",
      label: "Abandoned Shack",
      position: { x: -13.2, z: -30 },
      size: { w: 5.2, d: 4.8, h: 3.1 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_wooden.glb",
      rotationY: -0.19,
    },
    {
      id: "house-e-1",
      kind: "building",
      label: "Abandoned Shack",
      position: { x: 14.2, z: 29 },
      size: { w: 5.2, d: 4.8, h: 3.3 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_b.glb",
      rotationY: -0.11,
    },
    {
      id: "house-e-2",
      kind: "building",
      label: "Abandoned Shack",
      position: { x: 12.8, z: 19 },
      size: { w: 5.2, d: 4.8, h: 3.1 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_wooden.glb",
      rotationY: 0.16,
    },
    {
      id: "house-e-3",
      kind: "building",
      label: "Abandoned House",
      position: { x: 14.656888233714447, z: 6.006502657989223 },
      size: { w: 7.4, d: 6.2, h: 4.6 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_house_dilapidated.glb",
      rotationY: -3.12981601275819,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "house-e-4",
      kind: "building",
      label: "Abandoned Shack",
      position: { x: 25.25651955079055, z: 6.440324295533127 },
      size: { w: 5.2, d: 4.8, h: 3.4 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_a.glb",
      rotationY: 1.4762635834858684,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "house-e-5",
      kind: "building",
      label: "Abandoned Shack",
      position: { x: 15.5, z: -16 },
      size: { w: 5.2, d: 4.8, h: 3.2 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_weathered.glb",
      rotationY: -0.15,
    },
    {
      id: "house-e-6",
      kind: "building",
      label: "Abandoned Shack",
      position: { x: 12.6, z: -27 },
      size: { w: 5.2, d: 4.8, h: 3.5 },
      color: 0x6a5c4a,
      interactable: false,
      modelUrl: "/models/buildings/building_shack_c.glb",
      rotationY: 0.12,
    },
    {
      id: "sub-wreck-1",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -5.1750993438160755, z: 23.88504961095495 },
      size: { w: 3.738, d: 4.972, h: 1.5379 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-1.glb",
      collisionW: 3.364,
      collisionD: 4.4748,
      rotationY: 0.04,
      rotationX: 0,
      rotationZ: 0,
      positionY: -0.01620976619854919,
    },
    {
      id: "sub-wreck-2",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 5.4, z: 17 },
      size: { w: 4.4, d: 2.1, h: 1.631 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-14.glb",
      collisionW: 3.96,
      collisionD: 1.89,
      rotationY: 4.6708,
      positionY: 0,
    },
    {
      id: "sub-wreck-3",
      kind: "prop",
      label: "Abandoned Taxi",
      position: { x: -4.0136818070615945, z: 4.791501576683256 },
      size: { w: 2.0329, d: 4.972, h: 1.6882 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-48-taxi.glb",
      collisionW: 1.8295,
      collisionD: 4.4748,
      rotationY: -0.18108992818753025,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "sub-wreck-4",
      kind: "prop",
      label: "Rusted Van",
      position: { x: 5.6, z: 1 },
      size: { w: 2.7753, d: 5.72, h: 2.4783 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-26-van.glb",
      collisionW: 2.4981,
      collisionD: 5.148,
      rotationY: 3.14,
      positionY: 0,
    },
    {
      id: "sub-wreck-5",
      kind: "prop",
      label: "Wrecked Pickup",
      position: { x: -2.2, z: -3.4 },
      size: { w: 2.377, d: 5.4, h: 2.029 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-62-pickup.glb",
      collisionW: 2.139,
      collisionD: 4.86,
      rotationY: 1.22,
      positionY: 0,
    },
    {
      id: "sub-wreck-6",
      kind: "prop",
      label: "Wrecked Cabriolet",
      position: { x: 3.4, z: -5.6 },
      size: { w: 1.89, d: 4.2, h: 1.709 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-29-cabrio.glb",
      collisionW: 1.701,
      collisionD: 3.78,
      rotationY: 2.05,
      positionY: 0,
    },
    {
      id: "sub-wreck-7",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -5.4, z: -13 },
      size: { w: 2.2171, d: 4.972, h: 1.6882 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-20.glb",
      collisionW: 1.9956,
      collisionD: 4.4748,
      rotationY: 0.08,
      positionY: 0,
    },
    {
      id: "sub-wreck-8",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 5.5, z: -21 },
      size: { w: 2.031, d: 4.4, h: 1.464 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-3.glb",
      collisionW: 1.828,
      collisionD: 3.96,
      rotationY: 3.12,
      positionY: 0,
    },
    {
      id: "sub-wreck-9",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: -2.238609854633804, z: -28.273381256093714 },
      size: { w: 2.0182, d: 4.972, h: 1.3842 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-55.glb",
      collisionW: 1.8159,
      collisionD: 4.4748,
      rotationY: -0.27608755739516583,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "sub-wreck-10",
      kind: "prop",
      label: "Abandoned Ambulance",
      position: { x: -21, z: -4.2 },
      size: { w: 2.177, d: 5.2, h: 2.436 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-57-ambulance.glb",
      collisionW: 1.959,
      collisionD: 4.68,
      rotationY: 1.6,
      positionY: 0,
    },
    {
      id: "sub-wreck-11",
      kind: "prop",
      label: "Rusted Sedan",
      position: { x: 23, z: -4.4 },
      size: { w: 3.74, d: 1.887, h: 1.4161 },
      color: 0x6b5a42,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-9.glb",
      collisionW: 3.366,
      collisionD: 1.6983,
      rotationY: 3.1008,
      positionY: 0,
    },
    {
      id: "sub-lamp-1",
      kind: "prop",
      label: "Street Lamp",
      position: { x: -8.4, z: 24 },
      size: { w: 0.4444, d: 0.4444, h: 4 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-2.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0.082379629000914,
    },
    {
      id: "sub-lamp-2",
      kind: "prop",
      label: "Street Lamp",
      position: { x: 8.4, z: 8 },
      size: { w: 0.6, d: 0.6, h: 5.4 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_street-light-1.glb",
      rotationY: 3.141592653589793,
    },
    {
      id: "sub-lamp-3",
      kind: "prop",
      label: "Street Lamp",
      position: { x: -6.653903319354638, z: -8.924495702927423 },
      size: { w: 0.4444, d: 0.4444, h: 4 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-2.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "sub-lamp-4",
      kind: "prop",
      label: "Street Lamp",
      position: { x: 8.4, z: -24 },
      size: { w: 0.6, d: 0.6, h: 5.4 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_street-light-1.glb",
      rotationY: 3.141592653589793,
    },
    {
      id: "sub-traffic-light",
      kind: "prop",
      label: "Dead Traffic Light",
      position: { x: 8.6, z: -8.2 },
      size: { w: 0.3587, d: 0.3587, h: 2.75 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_traffic-light.glb",
      rotationY: -2.2,
    },
    {
      id: "sub-signpost",
      kind: "prop",
      label: "Street Sign",
      position: { x: -8.8, z: -1.4 },
      size: { w: 0.5, d: 0.5, h: 2.6 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_signpost.glb",
      rotationY: 0.6,
    },
    {
      id: "sub-tree-1",
      kind: "prop",
      label: "Dead Tree",
      position: { x: -23.039735930096192, z: 13.583518163741559 },
      size: { w: 1.4, d: 1.4, h: 5.2 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 0.4,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "sub-tree-2",
      kind: "prop",
      label: "Dead Tree",
      position: { x: 21.5, z: -16 },
      size: { w: 1.4, d: 1.4, h: 4.8 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: -1.1,
    },
    {
      id: "sub-tyres",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 10.5, z: 24.5 },
      size: { w: 1.4, d: 1.4, h: 1.1 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.3,
    },
    {
      id: "sub-barrel-fire",
      kind: "prop",
      label: "Cold Fire Barrel",
      position: { x: -10.6, z: -20.5 },
      size: { w: 0.8, d: 0.8, h: 1 },
      color: 0x5a5348,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0,
    },
    {
      id: "sub-loot-1",
      kind: "loot",
      label: "Dumpster",
      position: { x: 10.8, z: 12.5 },
      size: { w: 2.2, d: 1.3, h: 1.5 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "suburban-1",
      modelUrl: "/models/objects/obj_dumpster.glb",
      rotationY: 0,
    },
    {
      id: "sub-loot-3",
      kind: "loot",
      label: "Crate Stack",
      position: { x: 18.5, z: 22 },
      size: { w: 1.6, d: 1.4, h: 1.4 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "suburban-3",
      modelUrl: "/models/objects/obj_crates.glb",
      rotationY: 1.4,
    },
    {
      id: "sub-loot-4",
      kind: "loot",
      label: "Dumpster",
      position: { x: -11.542834286590082, z: -16.790351523084006 },
      size: { w: 2.2, d: 1.3, h: 1.5 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "suburban-4",
      modelUrl: "/models/objects/obj_dumpster-2.glb",
      rotationY: 1.7849630528865998,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "sub-loot-5",
      kind: "loot",
      label: "Toolbox",
      position: { x: 9.4, z: -18.5 },
      size: { w: 0.8, d: 0.5, h: 0.5 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "suburban-5",
      modelUrl: "/models/objects/obj_toolbox.glb",
      rotationY: 2.8,
    },
    {
      id: "sub-loot-6",
      kind: "loot",
      label: "Barrel",
      position: { x: -10.576523350480416, z: 29.19610946435632 },
      size: { w: 0.7, d: 0.7, h: 1 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "suburban-6",
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.3584073464102069,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "sub-loot-7",
      kind: "loot",
      label: "Milk Crate",
      position: { x: 19.6, z: -26 },
      size: { w: 0.6, d: 0.6, h: 0.5 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "suburban-7",
      modelUrl: "/models/objects/obj_crate-milk.glb",
      rotationY: 1.0584073464102062,
    },
    {
      id: "sub-loot-8",
      kind: "loot",
      label: "Wicker Basket",
      position: { x: -20.4, z: 26.5 },
      size: { w: 0.7, d: 0.7, h: 0.6 },
      color: 0x8a6a34,
      interactable: true,
      lootObjectId: "suburban-8",
      modelUrl: "/models/objects/obj_basket-wicker.glb",
      rotationY: 1.7584073464102064,
    },
    {
      id: "object-mtx3dj5i",
      kind: "prop",
      label: "Parkbench",
      position: { x: -8.914942779266541, z: 6.647741210828251 },
      size: { w: 1.601, d: 0.776, h: 0.85 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_parkbench.glb",
      rotationY: 0.5791237756192658,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "object-mtx3e8vf",
      kind: "prop",
      label: "Parkbench",
      position: { x: -12.487134991976458, z: 2.78197597465293 },
      size: { w: 1.601, d: 0.776, h: 0.85 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_parkbench.glb",
      rotationY: 1.0468357404904651,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: 0,
    },
    {
      id: "object-mtx3gatf",
      kind: "prop",
      label: "Street-lamp-3",
      position: { x: -6.349187016057154, z: 8.17866059367758 },
      size: { w: 2.185, d: 1.877, h: 4.2 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_street-lamp-3.glb",
      rotationY: 0.4619564246098283,
      rotationX: 0,
      rotationZ: 0,
      noClip: true,
      positionY: 0,
    },
    {
      id: "object-mtx3iy8j",
      kind: "prop",
      label: "Barrel",
      position: { x: -11.630247553042224, z: 12.932226009267836 },
      size: { w: 0.615, d: 0.615, h: 0.8250000000000001 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx3k66g",
      kind: "prop",
      label: "Plane-beechcraft-crash",
      position: { x: 23.897056008494012, z: 20.299322822797162 },
      size: { w: 8.7561, d: 6.9768, h: 2.16 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_plane-beechcraft-crash.glb",
      rotationY: 0.6443157931178919,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "object-mtx3l7y5",
      kind: "prop",
      label: "Tractor_modern",
      position: { x: 33.631902424187054, z: -16.136026910490962 },
      size: { w: 5.812, d: 4.756, h: 2.7 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_tractor_modern.glb",
      rotationY: 0.8160334886770887,
      rotationX: -3.141592653589793,
      rotationZ: -3.141592653589793,
      positionY: -0.1010150024941403,
    },
    {
      id: "object-mtx3o26c",
      kind: "prop",
      label: "Car-rust-58-police-us",
      position: { x: -4.722199097355505, z: -19.22878340357828 },
      size: { w: 1.933, d: 4.617, h: 1.5 },
      color: 0x9a8a6a,
      interactable: false,
      modelUrl: "/models/objects/obj_car-rust-58-police-us.glb",
      rotationY: -0.07719657028040593,
      rotationX: 0,
      rotationZ: 0,
      positionY: 0,
    },
    {
      id: "infill-suburban_streets-1",
      kind: "prop",
      label: "Sandbags",
      position: { x: 10.755, z: -0.695 },
      size: { w: 1.985, d: 0.288, h: 0.271 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.876,
    },
    {
      id: "infill-suburban_streets-2",
      kind: "prop",
      label: "Tarp",
      position: { x: -8.927, z: -27.392 },
      size: { w: 1.381, d: 1.187, h: 0.41 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.67,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-3",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -32.622, z: 2.353 },
      size: { w: 0.806, d: 1.017, h: 1.157 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 5.087,
    },
    {
      id: "infill-suburban_streets-4",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 7.799, z: -22.509 },
      size: { w: 0.753, d: 0.951, h: 1.082 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 5.01,
    },
    {
      id: "infill-suburban_streets-5",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -8.629, z: -29.846 },
      size: { w: 2.189, d: 1.977, h: 0.927 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.009,
    },
    {
      id: "infill-suburban_streets-6",
      kind: "prop",
      label: "Utility Post",
      position: { x: -17.143, z: -2.159 },
      size: { w: 1.253, d: 1.743, h: 3.638 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 3.02,
    },
    {
      id: "infill-suburban_streets-7",
      kind: "prop",
      label: "Tarp",
      position: { x: -15.228, z: 4.988 },
      size: { w: 1.481, d: 1.274, h: 0.44 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.288,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-8",
      kind: "prop",
      label: "Barrel",
      position: { x: -19.714, z: 27.337 },
      size: { w: 0.617, d: 0.617, h: 0.828 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.69,
    },
    {
      id: "infill-suburban_streets-9",
      kind: "prop",
      label: "Barrel",
      position: { x: -23.122, z: 8.545 },
      size: { w: 0.616, d: 0.616, h: 0.826 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.595,
    },
    {
      id: "infill-suburban_streets-10",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 9.178, z: -28.556 },
      size: { w: 1.752, d: 1.583, h: 0.742 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.138,
    },
    {
      id: "infill-suburban_streets-11",
      kind: "prop",
      label: "Tarp",
      position: { x: 28.819, z: 14.647 },
      size: { w: 1.35, d: 1.161, h: 0.401 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.572,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-12",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 2.826, z: -33.584 },
      size: { w: 5.635, d: 3.345, h: 3.411 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-1.glb",
      rotationY: 3.925,
    },
    {
      id: "infill-suburban_streets-13",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: -21.433, z: 11.463 },
      size: { w: 1.991, d: 1.798, h: 0.843 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.743,
    },
    {
      id: "infill-suburban_streets-14",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 26.865, z: -18.392 },
      size: { w: 2.084, d: 1.883, h: 0.883 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 5.116,
    },
    {
      id: "infill-suburban_streets-15",
      kind: "prop",
      label: "Tarp",
      position: { x: 13.852, z: -21.834 },
      size: { w: 1.204, d: 1.035, h: 0.357 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.801,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-16",
      kind: "prop",
      label: "Stump",
      position: { x: -10.25, z: -11.272 },
      size: { w: 0.632, d: 0.616, h: 0.692 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.692,
    },
    {
      id: "infill-suburban_streets-17",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 23.869, z: -10.507 },
      size: { w: 0.808, d: 1.02, h: 1.161 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0.045,
    },
    {
      id: "infill-suburban_streets-18",
      kind: "prop",
      label: "Broken Tree",
      position: { x: -29.076, z: 16.128 },
      size: { w: 7.114, d: 2.812, h: 2.992 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: 3.008,
    },
    {
      id: "infill-suburban_streets-19",
      kind: "prop",
      label: "Utility Post",
      position: { x: 0.692, z: -26.009 },
      size: { w: 1.358, d: 1.889, h: 3.942 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 4.409,
    },
    {
      id: "infill-suburban_streets-20",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -20.235, z: -27.277 },
      size: { w: 2.873, d: 0.144, h: 2.744 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 6.125,
    },
    {
      id: "infill-suburban_streets-21",
      kind: "prop",
      label: "Tarp",
      position: { x: 1.979, z: 9.637 },
      size: { w: 1.581, d: 1.36, h: 0.469 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.321,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-22",
      kind: "prop",
      label: "Stump",
      position: { x: 7.322, z: 19.401 },
      size: { w: 0.667, d: 0.651, h: 0.731 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.919,
    },
    {
      id: "infill-suburban_streets-23",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 19.702, z: -21.421 },
      size: { w: 1.859, d: 1.679, h: 0.787 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.311,
    },
    {
      id: "infill-suburban_streets-24",
      kind: "prop",
      label: "Tarp",
      position: { x: 16.28, z: -7.028 },
      size: { w: 1.257, d: 1.081, h: 0.373 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.306,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-25",
      kind: "prop",
      label: "Stump",
      position: { x: -10.099, z: -28.826 },
      size: { w: 0.65, d: 0.634, h: 0.712 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 5.151,
    },
    {
      id: "infill-suburban_streets-26",
      kind: "prop",
      label: "Stump",
      position: { x: 5.685, z: 23.573 },
      size: { w: 0.72, d: 0.702, h: 0.788 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.31,
    },
    {
      id: "infill-suburban_streets-27",
      kind: "prop",
      label: "Sandbags",
      position: { x: -25.659, z: -3.939 },
      size: { w: 1.616, d: 0.234, h: 0.22 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.91,
    },
    {
      id: "infill-suburban_streets-28",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 24.776, z: -16.9 },
      size: { w: 0.755, d: 0.953, h: 1.084 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0.606,
    },
    {
      id: "infill-suburban_streets-29",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 2.313, z: 16.486 },
      size: { w: 0.694, d: 0.877, h: 0.998 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.696,
    },
    {
      id: "infill-suburban_streets-30",
      kind: "prop",
      label: "Sandbags",
      position: { x: -26.171, z: -1.397 },
      size: { w: 1.501, d: 0.218, h: 0.204 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 0.66,
    },
    {
      id: "infill-suburban_streets-31",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 7.396, z: -14.574 },
      size: { w: 1.778, d: 1.606, h: 0.753 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 1.695,
    },
    {
      id: "infill-suburban_streets-32",
      kind: "prop",
      label: "Tarp",
      position: { x: 15.18, z: -2.857 },
      size: { w: 1.324, d: 1.139, h: 0.393 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.947,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-33",
      kind: "prop",
      label: "Stump",
      position: { x: -14.614, z: -7.046 },
      size: { w: 0.796, d: 0.777, h: 0.872 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.381,
    },
    {
      id: "infill-suburban_streets-34",
      kind: "prop",
      label: "Stump",
      position: { x: -10.637, z: 13.026 },
      size: { w: 0.765, d: 0.746, h: 0.838 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.207,
    },
    {
      id: "infill-suburban_streets-35",
      kind: "prop",
      label: "Tarp",
      position: { x: -20.985, z: -0.034 },
      size: { w: 1.475, d: 1.269, h: 0.438 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.904,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-36",
      kind: "prop",
      label: "Stump",
      position: { x: 21.278, z: -8.498 },
      size: { w: 0.77, d: 0.751, h: 0.843 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.527,
    },
    {
      id: "infill-suburban_streets-37",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 1.286, z: -15.446 },
      size: { w: 0.624, d: 0.787, h: 0.896 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 3.884,
    },
    {
      id: "infill-suburban_streets-38",
      kind: "prop",
      label: "Stump",
      position: { x: 29.709, z: -11.08 },
      size: { w: 0.62, d: 0.605, h: 0.679 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.538,
    },
    {
      id: "infill-suburban_streets-39",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 17.472, z: 16.279 },
      size: { w: 2.187, d: 1.976, h: 0.926 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 4.357,
    },
    {
      id: "infill-suburban_streets-40",
      kind: "prop",
      label: "Barrel",
      position: { x: 29.679, z: 7.033 },
      size: { w: 0.717, d: 0.717, h: 0.963 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.222,
    },
    {
      id: "infill-suburban_streets-41",
      kind: "prop",
      label: "Tarp",
      position: { x: -27.368, z: -19.534 },
      size: { w: 1.222, d: 1.051, h: 0.363 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.249,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-42",
      kind: "prop",
      label: "Tarp",
      position: { x: -26.268, z: -18.039 },
      size: { w: 1.576, d: 1.355, h: 0.468 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 5.108,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-43",
      kind: "prop",
      label: "Sandbags",
      position: { x: 30.552, z: -4.78 },
      size: { w: 2.065, d: 0.3, h: 0.281 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 3.215,
    },
    {
      id: "infill-suburban_streets-44",
      kind: "prop",
      label: "Stump",
      position: { x: -19.12, z: 10.004 },
      size: { w: 0.806, d: 0.786, h: 0.883 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.686,
    },
    {
      id: "infill-suburban_streets-45",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 17.728, z: -25.643 },
      size: { w: 0.629, d: 0.794, h: 0.904 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0.914,
    },
    {
      id: "infill-suburban_streets-46",
      kind: "prop",
      label: "Barrel",
      position: { x: 21.274, z: 12.423 },
      size: { w: 0.71, d: 0.71, h: 0.953 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 3.595,
    },
    {
      id: "infill-suburban_streets-47",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 0.234, z: 14.014 },
      size: { w: 2.385, d: 2.154, h: 1.01 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 0.626,
    },
    {
      id: "infill-suburban_streets-48",
      kind: "prop",
      label: "Barrel",
      position: { x: -16.829, z: 19.272 },
      size: { w: 0.773, d: 0.773, h: 1.037 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.68,
    },
    {
      id: "infill-suburban_streets-49",
      kind: "prop",
      label: "Stump",
      position: { x: -16.301, z: -24.688 },
      size: { w: 0.818, d: 0.798, h: 0.896 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.158,
    },
    {
      id: "infill-suburban_streets-50",
      kind: "prop",
      label: "Tarp",
      position: { x: -1.33, z: -18.951 },
      size: { w: 1.552, d: 1.335, h: 0.461 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 2.296,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-51",
      kind: "prop",
      label: "Barrel",
      position: { x: 26.554, z: -8.622 },
      size: { w: 0.788, d: 0.788, h: 1.058 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 2.526,
    },
    {
      id: "infill-suburban_streets-52",
      kind: "prop",
      label: "Barrel",
      position: { x: 13.175, z: -32.057 },
      size: { w: 0.669, d: 0.669, h: 0.898 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 4.569,
    },
    {
      id: "infill-suburban_streets-53",
      kind: "prop",
      label: "Wire Fence",
      position: { x: -8.967, z: -25.058 },
      size: { w: 2.834, d: 0.142, h: 2.708 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 4.986,
    },
    {
      id: "infill-suburban_streets-54",
      kind: "prop",
      label: "Stump",
      position: { x: 20.077, z: 12.756 },
      size: { w: 0.625, d: 0.61, h: 0.684 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.28,
    },
    {
      id: "infill-suburban_streets-56",
      kind: "prop",
      label: "Sandbags",
      position: { x: 11.436, z: -8.085 },
      size: { w: 1.596, d: 0.232, h: 0.217 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.624,
    },
    {
      id: "infill-suburban_streets-57",
      kind: "prop",
      label: "Stump",
      position: { x: 16.267, z: -29.875 },
      size: { w: 0.842, d: 0.821, h: 0.922 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.366,
    },
    {
      id: "infill-suburban_streets-58",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 26.18, z: -4.694 },
      size: { w: 0.645, d: 0.814, h: 0.926 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.474,
    },
    {
      id: "infill-suburban_streets-59",
      kind: "prop",
      label: "Sandbags",
      position: { x: 29.749, z: -17.324 },
      size: { w: 2.094, d: 0.304, h: 0.285 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.122,
    },
    {
      id: "infill-suburban_streets-60",
      kind: "prop",
      label: "Stump",
      position: { x: -7.86, z: 3.577 },
      size: { w: 0.807, d: 0.788, h: 0.884 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 2.224,
    },
    {
      id: "infill-suburban_streets-61",
      kind: "prop",
      label: "Stump",
      position: { x: 8.114, z: -3.58 },
      size: { w: 0.727, d: 0.709, h: 0.796 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.047,
    },
    {
      id: "infill-suburban_streets-62",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 10.082, z: -14.624 },
      size: { w: 2.03, d: 1.834, h: 0.86 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 2.398,
    },
    {
      id: "infill-suburban_streets-63",
      kind: "prop",
      label: "Utility Post",
      position: { x: -32.632, z: 6.099 },
      size: { w: 1.649, d: 2.294, h: 4.788 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 4.466,
    },
    {
      id: "infill-suburban_streets-64",
      kind: "prop",
      label: "Tarp",
      position: { x: -4.195, z: -8.812 },
      size: { w: 1.499, d: 1.289, h: 0.445 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 0.583,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-65",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 21.956, z: 5.395 },
      size: { w: 0.74, d: 0.934, h: 1.063 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.319,
    },
    {
      id: "infill-suburban_streets-66",
      kind: "prop",
      label: "Tyre Pile",
      position: { x: 17.301, z: -27.191 },
      size: { w: 2.397, d: 2.165, h: 1.015 },
      color: 0x2a2724,
      interactable: false,
      modelUrl: "/models/objects/obj_tyre-pile.glb",
      rotationY: 6.224,
    },
    {
      id: "infill-suburban_streets-67",
      kind: "prop",
      label: "Tarp",
      position: { x: -19.088, z: 23.877 },
      size: { w: 1.598, d: 1.374, h: 0.474 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.818,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-68",
      kind: "prop",
      label: "Sandbags",
      position: { x: -27.104, z: -13.113 },
      size: { w: 1.78, d: 0.258, h: 0.243 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.783,
    },
    {
      id: "infill-suburban_streets-69",
      kind: "prop",
      label: "Stump",
      position: { x: 10.82, z: -12.105 },
      size: { w: 0.694, d: 0.677, h: 0.76 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.87,
    },
    {
      id: "infill-suburban_streets-70",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: 33.821, z: -4.95 },
      size: { w: 0.577, d: 0.728, h: 0.829 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 2.794,
    },
    {
      id: "infill-suburban_streets-71",
      kind: "prop",
      label: "Stump",
      position: { x: -33.243, z: -0.682 },
      size: { w: 0.732, d: 0.714, h: 0.802 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.647,
    },
    {
      id: "infill-suburban_streets-72",
      kind: "prop",
      label: "Broken Tree",
      position: { x: 34.498, z: 3.838 },
      size: { w: 6.373, d: 2.519, h: 2.681 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_tree-broken-2.glb",
      rotationY: 2.743,
    },
    {
      id: "infill-suburban_streets-73",
      kind: "prop",
      label: "Sandbags",
      position: { x: 6.114, z: 32.97 },
      size: { w: 1.593, d: 0.231, h: 0.217 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 4.268,
    },
    {
      id: "infill-suburban_streets-74",
      kind: "prop",
      label: "Utility Post",
      position: { x: 27.355, z: 11.066 },
      size: { w: 1.647, d: 2.292, h: 4.782 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 6.167,
    },
    {
      id: "infill-suburban_streets-75",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -4.829, z: -30.795 },
      size: { w: 0.761, d: 0.961, h: 1.093 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 5.756,
    },
    {
      id: "infill-suburban_streets-76",
      kind: "prop",
      label: "Stump",
      position: { x: -18.497, z: 19.58 },
      size: { w: 0.849, d: 0.828, h: 0.929 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 3.562,
    },
    {
      id: "infill-suburban_streets-77",
      kind: "prop",
      label: "Tarp",
      position: { x: -14.576, z: -10.328 },
      size: { w: 1.265, d: 1.088, h: 0.375 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 4.821,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-78",
      kind: "prop",
      label: "Barrel",
      position: { x: -14.066, z: -3.93 },
      size: { w: 0.587, d: 0.587, h: 0.788 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 6.139,
    },
    {
      id: "infill-suburban_streets-79",
      kind: "prop",
      label: "Tarp",
      position: { x: 28.978, z: -14.003 },
      size: { w: 1.199, d: 1.031, h: 0.356 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 3.649,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-80",
      kind: "prop",
      label: "Sandbags",
      position: { x: 28.644, z: 1.765 },
      size: { w: 1.641, d: 0.238, h: 0.224 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.213,
    },
    {
      id: "infill-suburban_streets-81",
      kind: "prop",
      label: "Stump",
      position: { x: -0.229, z: 10.201 },
      size: { w: 0.812, d: 0.792, h: 0.89 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 1.358,
    },
    {
      id: "infill-suburban_streets-82",
      kind: "prop",
      label: "Wire Fence",
      position: { x: 19.413, z: -6.531 },
      size: { w: 2.797, d: 0.14, h: 2.671 },
      color: 0x5f5a50,
      interactable: false,
      modelUrl: "/models/objects/obj_fence-wire.glb",
      rotationY: 5.364,
    },
    {
      id: "infill-suburban_streets-83",
      kind: "prop",
      label: "Stump",
      position: { x: 29.286, z: 9.013 },
      size: { w: 0.828, d: 0.808, h: 0.907 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 4.887,
    },
    {
      id: "infill-suburban_streets-84",
      kind: "prop",
      label: "Utility Post",
      position: { x: 5.247, z: 21.066 },
      size: { w: 1.299, d: 1.807, h: 3.77 },
      color: 0x584a36,
      interactable: false,
      modelUrl: "/models/objects/obj_utility-post.glb",
      rotationY: 1.503,
    },
    {
      id: "infill-suburban_streets-85",
      kind: "prop",
      label: "Tarp",
      position: { x: -27.502, z: -7.234 },
      size: { w: 1.204, d: 1.035, h: 0.357 },
      color: 0x5d5a4a,
      interactable: false,
      modelUrl: "/models/objects/obj_tarp-roll.glb",
      rotationY: 1.956,
      noClip: true,
      positionY: -0.05,
    },
    {
      id: "infill-suburban_streets-86",
      kind: "prop",
      label: "Barrel",
      position: { x: -18.036, z: -9.834 },
      size: { w: 0.761, d: 0.761, h: 1.021 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 5.809,
    },
    {
      id: "infill-suburban_streets-87",
      kind: "prop",
      label: "Sandbags",
      position: { x: -17.249, z: 0.194 },
      size: { w: 1.838, d: 0.267, h: 0.251 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 1.569,
    },
    {
      id: "infill-suburban_streets-88",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -3.214, z: -16.099 },
      size: { w: 0.678, d: 0.856, h: 0.974 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 1.4,
    },
    {
      id: "infill-suburban_streets-89",
      kind: "prop",
      label: "Fire Barrel",
      position: { x: -23.219, z: -17.013 },
      size: { w: 0.734, d: 0.927, h: 1.054 },
      color: 0x5a4a34,
      interactable: false,
      modelUrl: "/models/objects/obj_fire-barrel.glb",
      rotationY: 0.347,
    },
    {
      id: "infill-suburban_streets-90",
      kind: "prop",
      label: "Sandbags",
      position: { x: -14.274, z: 30.653 },
      size: { w: 1.907, d: 0.277, h: 0.26 },
      color: 0x7a6d4e,
      interactable: false,
      modelUrl: "/models/objects/obj_sandbag-wall.glb",
      rotationY: 5.3,
    },
    {
      id: "infill-suburban_streets-91",
      kind: "prop",
      label: "Barrel",
      position: { x: 17.998, z: -10.92 },
      size: { w: 0.617, d: 0.617, h: 0.828 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 1.458,
    },
    {
      id: "infill-suburban_streets-92",
      kind: "prop",
      label: "Barrel",
      position: { x: -8.83, z: 33.075 },
      size: { w: 0.626, d: 0.626, h: 0.841 },
      color: 0x6b5a3c,
      interactable: false,
      modelUrl: "/models/objects/obj_barrel.glb",
      rotationY: 0.325,
    },
    {
      id: "infill-suburban_streets-93",
      kind: "prop",
      label: "Stump",
      position: { x: -8.516, z: -13.901 },
      size: { w: 0.618, d: 0.603, h: 0.677 },
      color: 0x4a4031,
      interactable: false,
      modelUrl: "/models/objects/obj_stump-roots.glb",
      rotationY: 0.151,
    },
  ],

  collisionZones: [
    {
      id: "sub-fog-n",
      label: "North Haze",
      position: { x: 0, z: 36 },
      size: { w: 76, d: 8 },
      fog: { color: 10134438, opacity: 0.34, height: 3.2 },
    },
    {
      id: "sub-fog-s",
      label: "South Haze",
      position: { x: 0, z: -36 },
      size: { w: 76, d: 8 },
      fog: { color: 10134438, opacity: 0.38, height: 3.2 },
    },
    {
      id: "sub-fog-w",
      label: "West Haze",
      position: { x: -34, z: 0 },
      size: { w: 10, d: 62 },
      fog: { color: 10134438, opacity: 0.3, height: 3.2 },
    },
    {
      id: "sub-fog-e",
      label: "East Haze",
      position: { x: 34, z: 0 },
      size: { w: 10, d: 62 },
      fog: { color: 10134438, opacity: 0.3, height: 3.2 },
    },
    {
      id: "zone-mtx3h2e0",
      label: "New Zone",
      position: { x: -6.525378953530226, z: 8.39227859675356 },
      size: { w: 0.537927982391615, d: 0.4238402929036437 },
      rotationY: 0,
    },
    {
      id: "zone-mtx3hrvm",
      label: "New Zone",
      position: { x: -4.048830372383685, z: 4.76875015410138 },
      size: { w: 1.0883177171128375, d: 4.009756208804152 },
      rotationY: -0.19160431222299482,
    },
  ],

  roads: [
    {
      id: "sub-main",
      label: "Main Street",
      surface: "asphalt_old",
      points: [{ x: 0, z: 38 }, { x: 0, z: 6 }, { x: -0.6, z: -10 }, { x: -0.6, z: -38 }],
      width: 7.2,
    },
    {
      id: "sub-cross",
      label: "Cross Street",
      surface: "asphalt_old",
      points: [{ x: -38, z: -4.2 }, { x: -2, z: -4.2 }, { x: 38, z: -4.6 }],
      width: 6,
    },
    {
      id: "sub-alley-w",
      label: "West Alley",
      surface: "dirt_path",
      points: [{ x: -9.2, z: 20 }, { x: -19, z: 19.2 }, { x: -27, z: 12 }],
      width: 2.3,
    },
    {
      id: "sub-alley-e",
      label: "East Alley",
      surface: "dirt_path",
      points: [{ x: 9.2, z: -12 }, { x: 20, z: -13.5 }, { x: 28, z: -21 }],
      width: 2.4,
    },
    {
      id: "road-mtx35eaa",
      label: "Dirt road (wide) 5",
      surface: "dirt_road",
      points: [{ x: 26.528, z: -1.478 }, { x: 26.734, z: 1.927 }, { x: 26.836, z: 3.48 }, { x: 27.003, z: 4.411 }, { x: 27.038, z: 5.193 }, { x: 26.85, z: 6.431 }],
      width: 2.1,
      tileLength: 3.6,
    },
    {
      id: "road-mtx369g7",
      label: "Dirt path (narrow) 6",
      surface: "dirt_path",
      points: [{ x: -9.23, z: 20.081 }, { x: -7.751, z: 20.22 }, { x: -7.238, z: 20.011 }, { x: -6.642, z: 19.982 }, { x: -5.905, z: 19.745 }, { x: -5.328, z: 19.612 }, { x: -4.701, z: 19.372 }, { x: -4.354, z: 19.307 }, { x: -3.972, z: 19.287 }, { x: -3.588, z: 19.246 }, { x: -3.541, z: 19.249 }],
      width: 2.4,
      tileLength: 4.2,
    },
    {
      id: "road-mtx372ep",
      label: "Dirt path (narrow) 7",
      surface: "dirt_path",
      points: [{ x: -27.06, z: 12.021 }, { x: -28.101, z: 10.933 }, { x: -28.995, z: 9.723 }, { x: -29.868, z: 8.186 }, { x: -30.542, z: 6.144 }, { x: -30.754, z: 3.651 }, { x: -30.892, z: 1.317 }, { x: -30.7, z: -0.87 }, { x: -30.749, z: -1.286 }],
      width: 2.5,
      tileLength: 3.2,
      opacity: 0.9,
    },
    {
      id: "road-mtx39arz",
      label: "Dirt road (wide) 8",
      surface: "dirt_road",
      points: [{ x: -3.608, z: 27.02 }, { x: -5.604, z: 27.04 }, { x: -6.879, z: 27.13 }, { x: -8.196, z: 27.17 }, { x: -9.274, z: 27.41 }, { x: -10.505, z: 27.531 }, { x: -11.517, z: 27.596 }, { x: -12.54, z: 27.461 }, { x: -13.197, z: 27.598 }, { x: -13.364, z: 27.575 }],
      width: 2.3,
      tileLength: 2.5,
    },
    {
      id: "road-mtx3atfm",
      label: "Dirt road (wide) 9",
      surface: "dirt_road",
      points: [{ x: 13.882, z: -1.355 }, { x: 14.029, z: -0.006 }, { x: 14.282, z: 1.268 }, { x: 14.314, z: 2.692 }, { x: 14.302, z: 2.9 }],
      width: 2.2,
      tileLength: 2.2,
    },
    {
      id: "road-mtx3csl7",
      label: "Dirt road (wide) 10",
      surface: "dirt_road",
      points: [{ x: -15.831, z: -7.181 }, { x: -15.788, z: -9.044 }, { x: -15.716, z: -11.002 }, { x: -15.692, z: -13.235 }],
      width: 2.4,
      tileLength: 2.6,
    },
    {
      id: "road-mtx3f8im",
      label: "Masoned foot path 11",
      surface: "masonry_path",
      points: [{ x: -4.207, z: 18.113 }, { x: -4.27, z: 8.512 }, { x: -4.49, z: 7.556 }, { x: -4.853, z: 7.172 }, { x: -5.478, z: 6.775 }, { x: -6.232, z: 6.321 }, { x: -7.327, z: 5.789 }, { x: -8.401, z: 5.375 }, { x: -9.253, z: 4.817 }, { x: -10.37, z: 3.897 }, { x: -11.379, z: 2.775 }, { x: -11.971, z: 1.772 }, { x: -12.591, z: 0.748 }, { x: -12.881, z: -0.069 }, { x: -13.794, z: -0.494 }, { x: -14.894, z: -0.489 }, { x: -16.091, z: -0.516 }, { x: -17.456, z: -0.62 }, { x: -19.213, z: -0.614 }, { x: -21.518, z: -0.538 }, { x: -29.574, z: -0.585 }],
      width: 1.4,
      tileLength: 1.4,
      opacity: 0.9,
    },
    {
      id: "road-mtx3q4ot",
      label: "Masoned foot path 12",
      surface: "masonry_path",
      points: [{ x: 4.293, z: 37.933 }, { x: 4.148, z: 0.253 }, { x: 4.128, z: -0.11 }, { x: 4.167, z: -0.275 }, { x: 4.263, z: -0.405 }, { x: 4.512, z: -0.53 }, { x: 4.914, z: -0.605 }, { x: 5.329, z: -0.636 }, { x: 8.044, z: -0.699 }, { x: 12.714, z: -0.736 }, { x: 37.891, z: -0.883 }],
      width: 1.5,
      tileLength: 1.4,
      opacity: 0.9,
    },
  ],

  npcs: {
  },

  dialog: {
  },
};
